<template>
  <v-flex>
    <v-card>
      <v-card-title primary-title>
        <v-layout row>
          <v-flex grow pa-1>
            <h1 class="headline">Charity</h1>
          </v-flex>
          <v-flex shrink pa-1>
            <v-btn dark color="primary" @click="toggleAddNewCharity">
              {{ btnAddNewCharityTitle }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>

      <AddCharity v-if="showAddNewCharity"></AddCharity>

      <v-card-text v-else>
        <template>
          <div>
            <v-text-field
              v-model="charitySearch"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <v-data-table
              :items="charities || []"
              :headers="charityTableHeaders"
              :expand="expand"
              item-key="id"
              :search="charitySearch"
            >
              <template v-slot:items="props">
                <tr @click="props.expanded = !props.expanded">
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.created_at_utc | formatDate }}</td>
                </tr>
              </template>
              <template v-slot:expand="props">
                <v-card flat>
                  <v-card-text> Charity ID: {{ props.item.id }} </v-card-text>
                  <v-card-text>
                    Revenue % to donate (hint): {{ props.item.rev_sharing_pct }}
                  </v-card-text>
                  <v-card-text>
                    Address (ETH): {{ props.item.eth_address }}
                  </v-card-text>
                  <v-card-text> Url: {{ props.item.url }} </v-card-text>
                  <v-card-text>
                    Description: {{ props.item.description }}
                  </v-card-text>
                </v-card>
              </template>
            </v-data-table>
          </div>
        </template>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import axios from "axios";
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";
import AddCharity from "./AddCharity";

export default {
  name: "CharityList",
  components: {
    AddCharity
  },
  data: function() {
    return {
      btnAddNewCharityTitle: "Add charity",
      showAddNewCharity: false,
      charities: null,
      charitySearch: "",
      expand: false,
      charityTableHeaders: [
        { text: "Name", value: "name" },
        {
          text: `Date added (${moment()
            .tz(moment.tz.guess())
            .format("z")})`,
          value: "created_at_utc"
        }
      ]
    };
  },

  mounted: async function() {
    axios.get("/api/v1/admin/charities").then(res => {
      this.charities = res.data;
    });
  },

  methods: {
    toggleAddNewCharity: function() {
      this.showAddNewCharity = !this.showAddNewCharity;
      this.btnAddNewCharityTitle = this.showAddNewCharity
        ? "Cancel"
        : "Add charity";
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/admin/CharityList.vue